import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import './TextArea.css';
import { InputAdornment } from '@mui/material';
import TubeTooltip from './TubeTooltip';
import TubeSubmit from './TubeSubmit';
import AIDialog from '../dialog/AIDialog';
import { useState } from 'react';

export default function TextArea(props){
    const {
        label,
        stateName,
        valueName,
        dispatchFunc,
        disabled,
        sx,
        className,
        description,
        children,
        ai,
        handleSubmit
    } = props;

    const value = useSelector((state) => state[stateName][valueName]);
    const id = useSelector((state) => state[stateName].id);
    const dispatch = useDispatch();
        
    const [ aiDialogOpen, setAIDialogOpen ] = useState(false);

    const handleChange = (value) => {
        dispatch(dispatchFunc({[valueName]: value}));
    }

    const endAdornment = ai ? (
        <InputAdornment position="end" className="text-area-adornment">
            <TubeTooltip trigger="hover" position="bottom" contentHtml="Generate with AI">
                <TubeSubmit
                    label={"AI"}
                    onClick={() => setAIDialogOpen(true)}
                    variant="outlined"
                    className={"tube-input-ai-button"}
                />
            </TubeTooltip>
        </InputAdornment>
    ) : null;
    
    return (
        <div className='text-area-wrapper' style={sx}>
            <TextField 
                id={valueName}
                label={label}
                variant="outlined"
                className={`text-area ${className} ${ai ? 'with-ai' : ''}`}
                value={value ? value : ""}
                disabled={disabled}
                onChange={(e) => handleChange(e.target.value)}
                multiline
                InputProps={{
                    endAdornment: endAdornment
                }}
                rows={4}
            />
            {(description || children) && (
                <div className='text-area-description'>
                    {description}
                    {children}
                </div>
            )}
            <AIDialog
                label={label}
                isOpen={aiDialogOpen}
                setIsOpen={setAIDialogOpen}
                field={valueName}
                model={stateName}
                id={id}
                original={value}
                dispatchFunc={dispatchFunc}
                handleSubmit={handleSubmit}
            />
        </div>
    );
}

TextArea.propTypes = {
    label: PropTypes.string.isRequired,
    stateName: PropTypes.string.isRequired,
    valueName: PropTypes.string.isRequired,
    dispatchFunc: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    sx: PropTypes.object,
    className: PropTypes.string,
    description: PropTypes.string,
    children: PropTypes.node,
    ai: PropTypes.bool,
    handleSubmit: PropTypes.func
};